import React from 'react'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import {pickAttributes} from '../helpers/utils'

export default function SelectInput (props) {

  const [labelWidth, setLabelWidth] = React.useState(0)
  const labelRef = React.useRef(null)
  const errorId = `${props.id}-error-text`
  React.useEffect(() => setLabelWidth(labelRef.current.offsetWidth), [])

  const controlAttributes = pickAttributes(props, 'control')
  const labelAttributes = pickAttributes(props, 'label')
  const selectAttributes = pickAttributes(props, 'select')

  return (
      <FormControl {...controlAttributes} >
        <InputLabel ref={labelRef} {...labelAttributes}>{props.caption}</InputLabel>
        <Select
          native
          aria-describedby={errorId}
          {...selectAttributes}
        >
          {props.children}
        </Select>
        <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
      </FormControl>
  )
}
